'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var DetailsCard = require('./DetailsCard/DetailsCard.js');
var Currency = require('./Currency.js');
var ItemImage = require('./ItemImage.js');
var SessionContext = require('../providers/SessionContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);

const PriceContent = _ref => {
  let {
    unitPrice,
    currency,
    locale,
    label
  } = _ref;
  return unitPrice ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, label && `${label}: `, /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
    value: unitPrice,
    locale: locale ?? undefined,
    currency: currency
  })) : null;
};
const ItemCardClaims = _ref2 => {
  var _itemDetails$eligibil, _itemDetails$eligibil2, _itemDetails$eligibil3, _itemDetails$color, _itemDetails$size;
  let {
    itemDetails,
    claimDetails,
    layout,
    additionalDetails,
    disabled,
    s
  } = _ref2;
  const {
    claimsItemAttrLabelColor,
    claimsItemAttrLabelPrice,
    claimsItemAttrLabelQuantity,
    claimsItemAttrLabelEligibleQuantity,
    claimsItemAttrLabelSize,
    claimsItemAttrLabelSku,
    claimsReasonLabel,
    claimsReasonItemDamaged,
    claimsReasonItemMissing,
    claimsReasonWrongItem,
    claimsReasonPackageMissing
  } = nthHookTranslations.useTranslations();
  const {
    localeCountry,
    localeLanguage
  } = SessionContext.useSession();
  const claimTypeTranslationKeyMap = {
    PackageMissing: claimsReasonPackageMissing ?? '',
    ItemDamaged: claimsReasonItemDamaged ?? '',
    ItemMissing: claimsReasonItemMissing ?? '',
    WrongItem: claimsReasonWrongItem ?? ''
  };
  const attrs = [];
  if (typeof itemDetails.quantity === 'number') {
    attrs.push({
      key: 'quantity',
      value: itemDetails.quantity,
      label: claimsItemAttrLabelQuantity ?? ''
    });
  }
  if ((_itemDetails$eligibil = itemDetails.eligibility) !== null && _itemDetails$eligibil !== void 0 && _itemDetails$eligibil.isEligible && typeof ((_itemDetails$eligibil2 = itemDetails.eligibility) === null || _itemDetails$eligibil2 === void 0 ? void 0 : (_itemDetails$eligibil3 = _itemDetails$eligibil2.ineligibilityReason) === null || _itemDetails$eligibil3 === void 0 ? void 0 : _itemDetails$eligibil3.quantity) === 'number' && itemDetails.eligibility.ineligibilityReason.quantity > 0) {
    var _itemDetails$eligibil4;
    // This shows an items eligibleQuantity when an item is
    // partially eligible. We know an item is partially eligible
    // it is marked as isEligible: true and has an ineligible quantity
    attrs.push({
      key: 'eligibleQuantity',
      label: claimsItemAttrLabelEligibleQuantity ?? '',
      value: (_itemDetails$eligibil4 = itemDetails.eligibility) === null || _itemDetails$eligibil4 === void 0 ? void 0 : _itemDetails$eligibil4.eligibleQuantity
    });
  }
  if ((_itemDetails$color = itemDetails.color) !== null && _itemDetails$color !== void 0 && _itemDetails$color.length) {
    attrs.push({
      key: 'color',
      value: itemDetails.color,
      label: claimsItemAttrLabelColor ?? ''
    });
  }
  if ((_itemDetails$size = itemDetails.size) !== null && _itemDetails$size !== void 0 && _itemDetails$size.length) {
    attrs.push({
      key: 'size',
      value: itemDetails.size,
      label: claimsItemAttrLabelSize ?? ''
    });
  }
  if (itemDetails.sku.length) {
    attrs.push({
      key: 'sku',
      value: itemDetails.sku,
      label: claimsItemAttrLabelSku ?? ''
    });
  }
  if (typeof itemDetails.unitPrice === 'number') {
    attrs.push({
      key: 'unitPrice',
      component: _ref3 => {
        let {
          item
        } = _ref3;
        return /*#__PURE__*/React__default["default"].createElement(PriceContent, {
          unitPrice: item.unitPrice,
          currency: item.currency,
          locale: `${localeLanguage ?? ''}_${localeCountry ?? ''}`,
          label: claimsItemAttrLabelPrice
        });
      }
    });
  }
  return /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardContainer, {
    layout: layout,
    s: s
  }, /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardLeftColumn, null, /*#__PURE__*/React__default["default"].createElement(ItemImage["default"], {
    src: itemDetails.thumbnailUrl,
    alt: itemDetails.name || '',
    sDefault: disabled ? {
      opacity: '0.5'
    } : undefined
  })), /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardRightColumn, null, /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardHeader, {
    s: disabled ? {
      opacity: '0.5'
    } : undefined
  }, itemDetails.name), /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardAttributesContainer, {
    s: disabled ? {
      opacity: '0.5'
    } : undefined
  }, attrs.map(_ref4 => {
    let {
      key,
      value,
      label,
      component: Component
    } = _ref4;
    return Component ? /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardAttribute, {
      key: key
    }, /*#__PURE__*/React__default["default"].createElement(Component, {
      item: itemDetails
    })) : /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardAttribute, {
      key: key
    }, label && `${label}: `, value);
  })), (claimDetails === null || claimDetails === void 0 ? void 0 : claimDetails.claimType) && /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardStrongText, {
    s: disabled ? {
      opacity: '0.5'
    } : undefined
  }, mustache__default["default"].render(claimsReasonLabel ?? '', {
    reason: claimTypeTranslationKeyMap[claimDetails === null || claimDetails === void 0 ? void 0 : claimDetails.claimType]
  })), additionalDetails));
};
var ItemCardClaims$1 = nthHookTranslations.withTranslationsProvider(ItemCardClaims, {
  translationKeys: ['claimsItemAttrLabelColor', 'claimsItemAttrLabelPrice', 'claimsItemAttrLabelQuantity', 'claimsItemAttrLabelEligibleQuantity', 'claimsItemAttrLabelSize', 'claimsItemAttrLabelSku', 'claimsReasonLabel', 'claimsReasonItemDamaged', 'claimsReasonItemMissing', 'claimsReasonWrongItem', 'claimsReasonPackageMissing']
});

exports["default"] = ItemCardClaims$1;
